import { render } from "./DashboardCryptos.vue?vue&type=template&id=39749674&scoped=true"
import script from "./DashboardCryptos.vue?vue&type=script&lang=js"
export * from "./DashboardCryptos.vue?vue&type=script&lang=js"

import "./DashboardCryptos.vue?vue&type=style&index=0&id=39749674&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39749674"]])

export default __exports__